import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

const getLockEnabled = nullBind(getAnyOrNull, 'lib.lockEnabled');

// DEPRECATED: selectLockEnabled is unnecessary, replace it with a direct selector from lib.lockEnabled
const selectLockEnabled = (state) => {
  const enabledBySalon = getLockEnabled(state);

  if (enabledBySalon === true) return true;
  if (enabledBySalon === false) return false;

  return null;
};

// noinspection JSUnusedGlobalSymbols
export default selectLockEnabled;
